import { supabase } from "@/supabase/supabase";
import { Lead, Assistant } from "@/types/video-call";

export class VideoCallDataService {
  /**
   * Fetch lead data by ID and organization
   */
  static async fetchLead(leadId: string, organizationId: string): Promise<Lead> {
    const { data, error } = await supabase
      .from("leads")
      .select("*")
      .eq("id", leadId)
      .eq("organization_id", organizationId)
      .single();

    if (error) {
      throw new Error(`Failed to fetch lead: ${error.message}`);
    }

    return data as Lead;
  }

  /**
   * Fetch all assistants
   */
  static async fetchAssistants(): Promise<Assistant[]> {
    const { data, error } = await supabase
      .from("assistants")
      .select("id, name, description, status")
      .order("name");

    if (error) {
      throw new Error(`Failed to fetch assistants: ${error.message}`);
    }

    return (data as Assistant[]) || [];
  }

  /**
   * Fetch assistant by ID
   */
  static async fetchAssistantById(assistantId: string): Promise<Assistant> {
    const { data, error } = await supabase
      .from("assistants")
      .select("id, name, description, status")
      .eq("id", assistantId)
      .single();

    if (error) {
      throw new Error(`Failed to fetch assistant: ${error.message}`);
    }

    return data as Assistant;
  }
}